import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-push-notification-container',
  templateUrl: './push-notification-container.component.html',
  styleUrls: ['./push-notification-container.component.scss']
})
export class PushNotificationContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
